import { useEffect, useMemo } from 'react';
import { playSoundLoop, Sound } from '~/assets/sounds';
import { useDarkMode } from '~/hooks';
import { Head } from '../../components/Head';
import { SpawnList } from '../../components/SpawnList';
import { StyledContainer } from './SpawnSelect.styled';

const SpawnSelect = () => {
	const isDark = useDarkMode();

	const sound = useMemo(
		() => (isDark ? Sound.CharacterDay : Sound.CharacterNight),
		[isDark],
	);

	const stopSound = useMemo(() => playSoundLoop(sound), [sound]);

	useEffect(() => {
		return () => {
			stopSound();
		};
	}, [stopSound]);

	return (
		<StyledContainer>
			<Head />
			<SpawnList />
		</StyledContainer>
	);
};

export { SpawnSelect };
